const ProgressBar = {
	variant: 'text2Steps', // text, text2Steps, roundedWithLabel, roundedWithoutLabel or false
	steps: [
		'Calcula tu precio',
		'Datos personales',
		'DNI/NIE',
		'Banco',
		'Resumen y garantías',
		'Firma',
	],
	textSteps: ['Calcula tu precio', 'Contrata tu seguro'],
};

export default ProgressBar;
